// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getListChildNewLocation } from '../../../../../../../common/elements/utils/elementLocationUtils';

// Components
import FileUploadForm from '../../../../../../components/tools/files/FileUploadForm';
import StyledButton from '../../../../../../components/buttons/StyledButton';
import ToolbarPopup from '../../../toolbarPopup/ToolbarPopup';

// Constants
import { ELEMENT_CREATION_SOURCES } from '../../../../../../../common/elements/elementConstants';

// Styles
import './FileUploadPopup.scss';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';

const getElementLocation = ({ currentBoardId }) => getListChildNewLocation({ listId: currentBoardId });

const FileUploadPopupContents = (props) => (
    <FileUploadForm
        {...props}
        className="FileUploadPopup"
        getElementLocation={getElementLocation}
        creationSource={ELEMENT_CREATION_SOURCES.FILE_UPLOAD_POPUP}
    >
        {(handleFileUpload) => (
            <div>
                <img src={require('./file-upload-form-illustration.png')} width={150} height={144} draggable={false} />

                <StyledButton className="primary" onClickFn={handleFileUpload}>
                    Upload a file or image
                </StyledButton>

                <div className="tip">Tip: the easiest way to upload a file is to drag it straight into a board.</div>
            </div>
        )}
    </FileUploadForm>
);

FileUploadPopupContents.propTypes = {
    currentBoardId: PropTypes.string,
};

const FileUploadPopup = (props) => (
    <ToolbarPopup
        {...props}
        popupId={PopupIds.FILE_UPLOAD}
        buttonSelector=".popup-trigger-fileUpload .Icon"
        className="file-upload-popup"
    >
        <FileUploadPopupContents {...props} uploadCallbackFn={props.closeFilePopup} />
    </ToolbarPopup>
);

FileUploadPopup.propTypes = {
    closeFilePopup: PropTypes.func,
};

export default FileUploadPopup;
